import { render, staticRenderFns } from "./UIEditor.vue?vue&type=template&id=1be02d66"
import script from "./UIEditor.vue?vue&type=script&lang=ts"
export * from "./UIEditor.vue?vue&type=script&lang=ts"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports